{% block uc_config_page %}
<sw-page class="uc-config-page">

    {% block uc_config_smart_bar_header %}
    <template #smart-bar-header>
        <h2>{{ $tc('sellops-ultimate-cart.config.title') }}</h2>
    </template>
    {% endblock %}

    {% block uc_config_smart_bar_actions %}
    <template #smart-bar-actions>
        <sw-button variant="ghost" @click="goToMilestones">
            {{ $tc('sellops-ultimate-cart.config.milestonesButton') }}
        </sw-button>
        <sw-button variant="ghost" @click="goToFreeProducts">
            {{ $tc('sellops-ultimate-cart.config.freeProductsButton') }}
        </sw-button>
        <sw-button variant="ghost" @click="goToCrossSellRules">
            {{ $tc('sellops-ultimate-cart.config.crossSellRulesButton') }}
        </sw-button>
        <sw-button variant="primary" :isLoading="isSaving" @click="onSave">
            {{ $tc('sellops-ultimate-cart.config.saveButton') }}
        </sw-button>
    </template>
    {% endblock %}

    {% block uc_config_content %}
    <template #content>
        <sw-card-view>

            <sw-card :title="$tc('sellops-ultimate-cart.theme.headline')">
                <p class="uc-config-page__subline">
                    {{ $tc('sellops-ultimate-cart.theme.subline') }}
                </p>
                <uc-theme-picker
                    :value="currentTheme"
                    @update:value="onThemeChange"
                />
            </sw-card>

            <sw-card :title="$tc('sellops-ultimate-cart.elements.headline')">
                <p class="uc-config-page__subline">
                    {{ $tc('sellops-ultimate-cart.elements.subline') }}
                </p>
                <uc-element-sorter
                    :value="elementOrder"
                    :disabled-keys="disabledElements"
                    @update:value="onElementOrderChange"
                    @update:disabledKeys="onDisabledElementsChange"
                />
            </sw-card>

            <sw-system-config
                ref="systemConfig"
                sales-channel-switchable
                domain="SellopsUltimateCart.config"
                @config-changed="onSystemConfigChanged"
                @sales-channel-changed="onSalesChannelChanged"
            />

        </sw-card-view>
    </template>
    {% endblock %}

</sw-page>
{% endblock %}
